import z from 'zod';
import useSWR from 'swr';
import { UserSchema } from 'packages/lib/api/annotations-app-api/contract';
import { apiGet } from 'packages/lib/api/annotations-app-api/rest';
import { message } from 'antd';

export function useUsers() {
  return useSWR('/roster-management/users', (url) =>
    apiGet(url, z.array(UserSchema).parse)
  );
}

export function useCurrentUser() {
  return useSWR('/roster-management/users/me', (url) =>
    apiGet(url, UserSchema.parse).catch((e) => {
      void message.warning(
        'Failed to fetch current user profile. User might not be in workforce management system.'
      );

      throw e;
    })
  );
}

export function getCurrentUser() {
  return apiGet('/roster-management/users/me', UserSchema.parse);
}

export function getCurrentUserSafely() {
  try {
    return getCurrentUser();
  } catch (e) {
    void message.warning(
      'Failed to fetch current user profile. User might not be in workforce management system.'
    );
    return null;
  }
}
